import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import ImageTextCard from "@components/WebsiteRevamp/ImageTextCard/ImageTextCard"
import Typography, {
	Size,
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {
	AdvancedSideAssetMainContent,
	AdvancedSideAssetModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./ManagementTeamSection.module.scss"

export type ManagementTeamSectionType = {
	data: AdvancedSideAssetMainContent[]
	dataTop?: AdvancedSideAssetModuleType
}

const ManagementTeamSection = (props: ManagementTeamSectionType) => {
	return (
		<section>
			<Separator size={128}>
				<ContainerWrapper>
					<Typography
						variant={Variant.SectionTitle}
						content={props.dataTop?.sectionTitle}
					/>
					<Typography
						variant={Variant.Description}
						content={props.dataTop?.sectionSubtitle}
						size={Size.XS}
						style={{
							maxWidth: "1023px",
						}}
					/>
					<Separator />
					<Separator className={styles.cardContainer} withoutMeasure>
						{props.data.map(
							(
								element: AdvancedSideAssetMainContent,
								index: number,
							) => {
								return (
									<ImageTextCard
										key={index}
										className={styles.cardBox}
										contentContainer={
											styles.contentContainer
										}
										buttonContainerProps={{
											className:
												styles.buttonContainerPropsCLass,
										}}
										// imageProps={{}}
										imageProps={{
											imageClassName: styles.image,
											containerClassName:
												styles.imageContainer,
										}}
										contentProps={{
											data: element,
											titleProps: {
												stripHtml: true,
											},
											subtitleProps: {
												stripHtml: true,
											},
											contentProps: {
												stripHtml: true,
												truncate: 250,
											},
										}}
									/>
								)
							},
						)}
					</Separator>
				</ContainerWrapper>
			</Separator>
			<Separator />
		</section>
	)
}

export default ManagementTeamSection
